<template>
  <div class="main tabs_main" style="height:89%">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">钢筋名称：</span>
        <el-input v-model="search.steelName" :size="size" clearable placeholder="请输入钢筋名称"></el-input>
      </div>
      <div class="header_item">
        <el-button   :size="size" icon="el-icon-search" v-if="showButton('search')" @click="searchButtonInfo(true)">查询</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="dataList"
        :cell-style="cellStyle"
        height="100%">
        <el-table-column align="center" label="序号" width="60">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="steelName" label="钢筋名称" align="center"></el-table-column>
        <el-table-column prop="steelModel" label="型号规格" align="center" ></el-table-column>
        <el-table-column prop="unit" label="计量单位" align="center"></el-table-column>
        <el-table-column prop="stock" label="实时库存" align="center" >
          <template #default="{row}">
                {{row.stock === null?0:row.stock}}
            </template>
        </el-table-column>
        <el-table-column prop="alarmCount" label="库存预警数据" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="updateProp(row)">库存校正</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('update')" @click="updatePropAlarm(row)">预警设置</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '预警设置' : '库存校正'"
      :close-on-click-modal="false"
      :visible.sync="asyncVisible"
      width="35%">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="auto" class="rule_form">
        <el-form-item label="钢筋名称：" prop="steelName">
          <el-input v-model="ruleForm.steelName" :size="size" clearable placeholder="请输入钢筋名称" :disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item label="规格型号：" prop="steelModel">
          <el-input v-model="ruleForm.steelModel" :size="size" clearable placeholder="请输入规格型号" :disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item label="预警数量：" prop="alarmCount" v-if="asyncTitle">
          <el-input v-model="ruleForm.alarmCount" :size="size" clearable placeholder="请输入预警数量" ></el-input>
        </el-form-item>
        <el-form-item label="库存重量：" prop="stock" v-if="!asyncTitle">
          <el-input v-model="ruleForm.stock" :size="size" clearable placeholder="请输入库存重量" :disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item label="校正重量：" prop="correctionNum" v-if="!asyncTitle">
          <el-input v-model="ruleForm.correctionNum" :size="size" clearable placeholder="请输入校正重量" @blur="changeAfter"></el-input>
        </el-form-item>
        <el-form-item label="校正后重量：" prop="correctionAfter" v-if="!asyncTitle">
          <el-input v-model="ruleForm.correctionAfter" :size="size" clearable placeholder="请输入校正重量" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="remark" v-if="!asyncTitle">
          <el-input v-model="ruleForm.remark" :size="size" type="textarea" :rows="2" clearable placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncVisible = false">取 消</el-button>
        <el-button @click="asyncTitle ? submitInsert() : submitUpdate()">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from '../../../pinia/index';
import { throttle, changeSize } from '../../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    data() {
      return {
        size: changeSize(), // 组件尺寸
        pageNum: 1,
        pageSize: 10,
        search:{},//查询条件
        total: 0,
        loading: false,
        disabled:false,//是否禁止修改
        dataList: [], //库存管理信息列表
        asyncTitle: true, // 对话框title 新增：true  修改：false
        asyncVisible: false, // 添加 修改对话框
        ruleForm: {
        }, // 按钮表单
        rules: {
          steelName: [{
            required: true,
            message: '请输入钢筋名称',
            trigger: 'blur'
          }],
          steelModel: [{
            required: true,
            message: '请输入规格型号',
            trigger: 'blur'
          }],
          stock: [{
            required: true,
            message: '请输入库存重量',
            trigger: 'blur'
          }],
          correctionNum: [{
            required: true,
            message: '请输入校正重量',
            trigger: 'blur'
          }],
          correctionAfter: [{
            required: true,
            message: '请输入校正后重量',
            trigger: 'blur'
          }],
          alarmCount: [{
            required: true,
            message: '请输入预警数量',
            trigger: 'blur'
          }],
        },
      }
    },
    watch: {
      asyncVisible(bol) {
        if(!bol) {
          this.ruleForm = {};
          this.$refs.ruleForm.resetFields();
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
    },
    methods: {
      //超过某个值变颜色
      cellStyle({row,column}){
        if(row.stock <= row.alarmCount &&column.property =="stock"){
          return {
            'color':'red'
          }
        }
      },
      //计算出校正后重量
      changeAfter(){
        const num1Digits = (this.ruleForm.stock.toString().split('.')[1] || '').length;
        const num2Digits = (this.ruleForm.correctionNum.toString().split('.')[1] || '').length;
        const baseNum = Math.pow(10, Math.max(num1Digits, num2Digits));
        const afterValue =  (this.ruleForm.stock * baseNum + this.ruleForm.correctionNum * baseNum) / baseNum;
        this.$set(this.ruleForm,'correctionAfter', isNaN(afterValue) ? '' : afterValue);
        
      },
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},this.search,{
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        this.loading = true;
        this.$api.Rebar.searchType(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.dataList = res.data.list;
          }
          this.loading = false;
        })
      },
      // 库存校正按钮信息
      updateProp(row) {
        this.asyncTitle = false;
        this.asyncVisible = true;
        this.disabled = true
        this.$api.Rebar.detailsType({steelId: row.steelId}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.ruleForm = res.data
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      //预警设置
      updatePropAlarm(row){
        this.asyncTitle = true;
        this.asyncVisible = true;
        this.disabled = true
        this.$api.Rebar.detailsType({steelId: row.steelId}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.ruleForm = res.data
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      //提交预警设置
      submitInsert: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            params.alarmCount = this.ruleForm.alarmCount*1
            this.$api.Rebar.setAlarmInvent(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('设置成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交库存校正按钮信息
      submitUpdate: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            params.correctionNum = this.ruleForm.correctionNum*1
            params.correctionBefore = this.ruleForm.stock*1
            this.$api.Rebar.updateInvent(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('修改成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="scss" scoped>
@import'@/style/layout-main.scss';
</style>